import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map, TileLayer, Pane, FeatureGroup, Popup, WMSTileLayer, GeoJSON, Circle } from 'react-leaflet';
import { CoordinatesControl } from 'react-leaflet-coordinates'
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';

// import VectorGridDefault from 'react-leaflet-vectorgrid';

import classes from './Webgis.module.css';
import MapToolBar from '../../components/MapToolBar/MapToolBar';
import MapToolBarMobile from '../../components/MapToolBarMobile/MapToolBarMobile';
import MapLayersPanel from '../../components/MapLayersPanel/MapLayersPanel';
import CloseButton from '../../components/UI/Buttons/CloseButton';
import Spinner from '../../components/Spinner/Spinner';
import LayerItem from '../../components/LayerItem/LayerItem';
import * as actions from '../../store/actions/index';


// const VectorGrid = withLeaflet(VectorGridDefault);


class Webgis extends Component {
    
    state={
        mapRef:null,
        popupCenter:null,
        popupKey:null,
        popupFullScreen:false,
        hideToolbars:false,
        displayOpacityIndex: -1,
        showInfo:false,
        mapZoom:7
    }

    componentDidMount () {
        this.props.onGetFireYears(this.props.geoserverUrl);
    }

    openOpacity = (layerIndex) => {
        if (layerIndex === this.state.displayOpacityIndex) {
            this.setState({displayOpacityIndex: -1});
        } else {
            this.setState({displayOpacityIndex: layerIndex});
        }
    }

    onZoom(){
        this.setState({mapZoom:this.state.mapRef.leafletElement.getZoom()});

        if (this.state.mapZoom > 9){
            this.props.onShowFirePolygons();
        } else {
            this.props.onShowFirePoints();
        }
    }

    onMapClick(e) {
        const visibleLayers = [];
        this.props.mapLayers.forEach(mapLayer => {
            if (mapLayer.visible){
                visibleLayers.push(mapLayer)
            }
        });

        this.prepareGetFeatureInfo(e.latlng)
    }

    prepareGetFeatureInfo(latlng){
        var d = new Date();
        this.setState({popupCenter:latlng, popupKey: 'popup_' + d.getMilliseconds()}); // Get time in miliseconds. The popup key will be based on this and prevent flickering while the daa is loaded

        const LAT = latlng.lat;
        const LNG = latlng.lng;
        const BBOX = this.state.mapRef.leafletElement.getBounds().toBBoxString();
        const WIDTH = this.state.mapRef.leafletElement.getSize().x;
        const HEIGHT = this.state.mapRef.leafletElement.getSize().y;

        const bds = this.state.mapRef.leafletElement.getBounds();
        const w = bds.getNorthEast().lng - bds.getSouthWest().lng;
        const h = bds.getNorthEast().lat - bds.getSouthWest().lat;
        const X = (((LNG - bds.getSouthWest().lng) / w) * WIDTH).toFixed(0);
        const Y = (((bds.getNorthEast().lat - LAT) / h) * HEIGHT).toFixed(0);

        const URL = 'wms?request=GetFeatureInfo&service=WMS&version=1.1.1&queryVisible=true&srs=EPSG%3A4326&format=image%2Fpng&bbox=' + BBOX + '&width=' + WIDTH + '&height=' + HEIGHT + '&info_format=application/json&x=' + X + '&y=' + Y + '&exceptions=application%2Fvnd.ogc.se_xml';
        const mapInfoLayers = this.getInfoLayers(this.props.mapLayers);
        // let layers = [];
        // const queryMapInfoLayers = this.getInfoLayers(this.props.queryMapLayers);
        // layers = [...mapInfoLayers, ...queryMapInfoLayers];

        if (mapInfoLayers.length > 0){
            this.props.onChangeFeaturePanel("reset");
            this.props.onGetFeatureInfo(URL, mapInfoLayers);
        }
    }

    getInfoLayers(collection){
        let layers = [];
        collection.forEach(mapLayer => {
            if (mapLayer.connection === "wms" && mapLayer.visible === true){
                if(mapLayer.data.layer === "burned_areas:fires_per_year" || mapLayer.data.layer === "burned_areas:fires_per_year_points"){
                    layers.unshift({layerName:mapLayer.data.layer, layerUrl:this.props.geoserverUrl, layerLabel:mapLayer.label, layerViewparams:mapLayer.viewparams, layerProperties:mapLayer.layerProperties});
                } else {
                    layers.push({layerName:mapLayer.data.layer, layerUrl:this.props.geoserverUrl, layerLabel:mapLayer.label, layerViewparams:mapLayer.viewparams, layerProperties:mapLayer.layerProperties});
                }
            }
        });

        return layers;
    }

    closePopup = () => {
        this.setState({popupFullScreen:false});
        this.props.onClosePopup();
    }

    toggleFullScreen = () => {
        const toggle = !this.state.popupFullScreen;
        this.setState({popupFullScreen:toggle});
    }

    hideToolbars = () => {
        const toggle = !this.state.hideToolbars;
        this.setState({hideToolbars:toggle});
    }

    zoomToBounds = (newBounds) => {
        this.state.mapRef.leafletElement.fitBounds(newBounds)
    }

    render () {
        let mapClasses = [classes.Map];
        let tileLayers = [];
        let legendItems = [];
        let envString = "";

        if (this.props.mapLayers.length > 0){
            this.props.mapLayers.forEach((mapLayer,index) => {
                if (mapLayer.visible){
                    if (mapLayer.style.env){
                        envString = "&env=color:" + mapLayer.style.env;
                    } else {
                        envString = "";
                    }

                    tileLayers.push(
                        <FeatureGroup key={`fg_${index}`}>
                            <Pane 
                                style={{zIndex: 400 + mapLayer.zIndex}}>

                                <WMSTileLayer
                                    format="image/png"
                                    transparent={true}
                                    onLoading={() => this.props.onAddLayerLoading(index, "mapLayersLoading")}
                                    onLoad={() => this.props.onRemoveLayerLoading(index, "mapLayersLoading")}
                                    layers={mapLayer.data.layer}
                                    opacity={mapLayer.layerOpacity}
                                    url={this.props.geoserverUrl + "wms?viewparams=" + mapLayer.viewparams + envString}
                                />
                            </Pane>
                        </FeatureGroup>
                    )
                }

                legendItems.push(
                    <LayerItem 
                        key={`layerItem_${index}`} 
                        index={index} 
                        mapLayers={this.props.mapLayers} 
                        collection="mapLayers"
                        mapLayer={mapLayer} 
                        showSymbol 
                        showVisibility
                        showOpacity
                        opacityClickHandle={() => this.openOpacity(index)}
                        displayOpacityIndex={this.state.displayOpacityIndex}
                    />
                );
                
            })
        }

        // Popup ---------------------------
        let fullScreenPopupClasses = [classes.PopupFullScreenWrapper];
        let popupHeader = null
        let popupContent = <div className={classes.PopupContentWrapper}></div>

        popupHeader = <div className={classes.ToolRow}>
                        {this.props.loadingFeatureInfo ?
                            <div className={classes.SpinnerWrapper}>
                                <Spinner themeLight />
                            </div>
                            :
                            this.props.featureInfoLayers.length > 0 ?
                                <div className={classes.ToolRowNav}>
                                    <svg 
                                        className={this.props.currentFeatureInfoLayer === 1 ? [classes.ToolRowNavSvg,classes.Disabled].join(' ') : classes.ToolRowNavSvg}
                                        onClick={() => this.props.onChangeFeaturePanel("subtract")} 
                                        xmlns='http://www.w3.org/2000/svg' viewBox='0 0 192 512'>
                                        <path d='M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z'></path>
                                    </svg>
                                    <span>{this.props.currentFeatureInfoLayer} / {this.props.featureInfoLayers.length}</span>
                                    <svg 
                                        className={this.props.currentFeatureInfoLayer === this.props.featureInfoLayers.length ? [classes.ToolRowNavSvg,classes.Disabled].join(' ') : classes.ToolRowNavSvg}
                                        onClick={() => this.props.onChangeFeaturePanel("add")} 
                                        xmlns='http://www.w3.org/2000/svg' viewBox='0 0 192 512'>
                                        <path d='M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z'></path>
                                    </svg>
                                </div>
                                : null
                        }
                        
                        <div className={classes.ToolRowActions}>
                            <svg className={this.state.popupFullScreen === true ? classes.Hidden : null} onClick={this.toggleFullScreen} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
                                <path d='M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z'></path>
                            </svg>
                            <svg className={this.state.popupFullScreen === false ? classes.Hidden : null} onClick={this.toggleFullScreen} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path d="M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"></path>
                            </svg>
                            <div className={classes.CloseButtonWrapper}>
                                <CloseButton clicked={this.closePopup} />
                            </div>
                        </div>
                    </div>

        if (this.props.featureInfoLayers.length > 0){
            popupContent = <div className={classes.PopupContentWrapper}>
                                {this.props.featureInfoLayers.map((featureInfoLayer,index) => 
                                    <div
                                        key={index}
                                        className={this.props.currentFeatureInfoLayer === index + 1 ? [classes.FeaturePanel, classes.Active].join(' ') : classes.FeaturePanel}>
                                        
                                        <h4 className={classes.LayerName}>{featureInfoLayer.layerLabel}</h4>
                                        
                                        <ul className={classes.PopupProperties}>
                                            {Object.keys(featureInfoLayer.layerData.data.features[0].properties).map(function(key,index) {
                                                if (featureInfoLayer.layerProperties[key]){
                                                    let propertyValue = featureInfoLayer.layerData.data.features[0].properties[key];

                                                    if (key === "linkmap"){
                                                        propertyValue = <a target="_blank" href={featureInfoLayer.layerData.data.features[0].properties[key]}>Link</a>

                                                    } else if (key === "areaha" || key === "areasqkm" || key === "area_ha"){
                                                        propertyValue = propertyValue.toFixed(2);
                                                    }
                                                    
                                                    return <li key={`popup_property_-${Math.floor(Math.random() * 100000)}`} className={classes.PropertyRow}>
                                                                <span className={index % 2 ? classes.OddRow : classes.EvenRow}>{featureInfoLayer.layerProperties[key]}:</span>
                                                                <span className={index % 2 ? classes.OddRow : classes.EvenRow}>{propertyValue}</span>
                                                            </li>
                                                }
                                                    
                                            })}
                                         </ul>
                                    </div>
                                )}
                            </div>
        } else {
            popupContent = <div className={classes.PopupContentWrapper}>
                                <span className={classes.NoInfo}>Δεν υπάρχουν πληροφορίες</span>
                            </div>
        }

        if (this.state.popupFullScreen){
            mapClasses.push(classes.MapPopupFullScreen);
            fullScreenPopupClasses.push(classes.Show);
        }
        // ---------------------------

        return(
            <div className={classes.WebGisWrapper}>
                <div className={fullScreenPopupClasses.join(' ')}>
                    <div className={classes.Curtain}></div>
                    <div className={classes.PopupFullScreen}>
                        {popupHeader}
                        {this.props.loadingFeatureInfo === false ?
                            popupContent
                            : <div></div>
                        }
                    </div>
                </div>
                
                <Map 
                    className={mapClasses.join(' ')} 
                    // ref={ref => this.mapRef = ref}
                    ref={ref => !this.state.mapRef && this.setState({ mapRef: ref })}
                    zoomControl={false}
                    onClick={(e) => this.onMapClick(e)}
                    onZoom={() => this.onZoom()}
                    maxZoom={18}
                    bounds={this.props.mapBounds}>

                    {this.props.basemapLayers[this.props.selectedBasemap].isGoogle ? 
                        <ReactLeafletGoogleLayer 
                            key={this.props.basemapLayers[this.props.selectedBasemap].name}
                            googleMapsLoaderConf={{KEY: this.props.basemapLayers[this.props.selectedBasemap].key}}
                            type={this.props.basemapLayers[this.props.selectedBasemap].name} />
                        : 
                        <TileLayer 
                            attribution={this.props.basemapLayers[this.props.selectedBasemap].attribution}
                            url={this.props.basemapLayers[this.props.selectedBasemap].url}
                        />
                    }

                    {/* <VectorGrid 
                        type = 'protobuf'
                        url = 'http://192.168.1.7:8080/geoserver/gwc/service/tms/1.0.0/opengeo:countries@EPSG%3A4326@pbf/{z}/{x}/{-y}.pbf'
                        subdomains = '0123'
                    /> */}

                    {tileLayers}

                    {this.props.showPopup === true ?
                        <Popup 
                            key={this.state.popupKey}
                            className={classes.Popup}
                            position={this.state.popupCenter}>
                            
                                {popupHeader}

                                {this.props.loadingFeatureInfo === false ?
                                    popupContent
                                    : <div></div>
                                }

                        </Popup>

                        :null
                    }

                    <CoordinatesControl 
                        coordinates="decimal"
                        position="bottomleft"
                    />

                </Map>

                <MapToolBar 
                    mapRef = {this.state.mapRef}
                    onHideToolbars={this.hideToolbars} 
                    hideToolbars={this.state.hideToolbars}
                    zoomExtent={() => this.zoomToBounds([[34.5, 17.13],[41.80,30.68]])}
                />
                <MapLayersPanel 
                    mapRef = {this.state.mapRef} 
                    hideToolbars={this.state.hideToolbars} 
                    legendItems={legendItems}
                />

                <MapToolBarMobile
                    mapRef = {this.state.mapRef}
                    legendItems={legendItems}
                    zoomExtent={() => this.zoomToBounds([[34.5, 17.13],[41.80,30.68]])}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        geoserverUrl: state.system.geoserverUrl,
        mapBounds: state.webgis.mapBounds,
        basemapLayers:state.webgis.basemapLayers,
        selectedBasemap:state.webgis.selectedBasemap,
        mapLayers: state.layerItems.mapLayers,
        featureInfoLayers: state.webgis.featureInfoLayers,
        currentFeatureInfoLayer: state.webgis.currentFeatureInfoLayer,
        loadingFeatureInfo: state.webgis.loadingFeatureInfo,
        showPopup: state.webgis.showPopup,
        fireYears: state.layerItems.fireYears
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onGetFeature: (mapLayers, latlng) => dispatch(actions.getFeature(mapLayers,latlng)),
        onChangeFeaturePanel: (action) => dispatch(actions.changeFeaturePanel(action)),
        onClosePopup: () => dispatch(actions.closePopup()),
        onAddLayerLoading: (mapLayerIndex, collection) => dispatch(actions.addLayerLoading(mapLayerIndex, collection)),
        onRemoveLayerLoading: (mapLayerIndex, collection) => dispatch(actions.removeLayerLoading(mapLayerIndex, collection)),
        onGetFeatureInfo: (url, layers) => dispatch(actions.getFeatureInfo(url, layers)),
        onGetFireYears: (geoserverUrl) => dispatch(actions.getFireYears(geoserverUrl)),
        onShowFirePolygons: () => dispatch(actions.showFirePolygons()),
        onShowFirePoints: () => dispatch(actions.showFirePoints())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Webgis);